import React from "react";
import { CustomSimpleSelect } from "../customSelect";
import "./styles.scss";

const FilterTabs = ({
  handleChange,
  tab,
  options = [
    {
      value: "all",
      name: "All",
      key: "all",
      label: "All",
    },
    {
      value: "main",
      name: "Main",
      key: "main",
      label: "Main",
    },
    {
      value: "sub",
      name: "Sub-Accounts",
      key: "sub",
      label: "Sub-Accounts",
    },
  ],
}) => {
  return (
    <div className="view-all-wrapper">
      <CustomSimpleSelect
        dropdownMatchSelectWidth={false}
        style={{ width: 180 }}
        className="table-type"
        value={tab}
        onChange={handleChange}
        options={options}
      />
    </div>
  );
};
export default FilterTabs;
